import {initSession} from "./session";
import {SessionData} from "./type";

let sessionData: SessionData;

export async function startCoachliTracker(siteId: string) {
  // console.log({sessionData});
  sessionData = await initSession(siteId);
}

export function getSessionData(): SessionData {
  // console.log({sessionData});
  return sessionData;
}
